<template>
    <div class="landing-page">
      <LandingHero id="home" />
      <PlatformLogos />
            <ActionComponent />
      <FeaturesComponent />
      <ScrollingComponent />
      <PlaylistComponent  />
      <ActivateComponent id="activate" />
  
      <FaqComponent />
   
   
    </div>
  </template>
  
  <script>
  import LandingHero from "@/components/LandingTop.vue";
  import PlatformLogos from "@/components/PlatformLogos.vue";
import FeaturesComponent from "@/components/FeaturesComponent.vue"
import ScrollingComponent from "@/components/ScrollingComponent.vue"
import ActivateComponent from "@/components/ActivateComponent.vue"
import PlaylistComponent from "@/components/PlaylistComponent.vue"
import FaqComponent from "@/components/FaqComponent.vue"
import ActionComponent from "@/components/ActionComponent.vue"
  export default {
    name: "HomeView",
    components: {
      ActionComponent,
      LandingHero,
      PlatformLogos,
      FeaturesComponent,
      ScrollingComponent,
      PlaylistComponent,
      ActivateComponent,
      FaqComponent

    },
  };
  </script>
  
  <style scoped>
  .landing-page {
    display: flex;
    flex-direction: column;
  
  }
  </style>
  